export default __webpack_public_path__ + "static/media/volume-mute.93b45b54.svg";